/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
export var NAVIGATION_REQUEST_NAVIGATION = 'NAVIGATION_REQUEST_NAVIGATION';
export var NAVIGATION_REQUEST_NAVIGATION_WITH_ID = 'NAVIGATION_REQUEST_NAVIGATION_WITH_ID';
export var NAVIGATION_REQUEST_SAML_BACK = 'NAVIGATION_REQUEST_SAML_BACK';
export var NAVIGATION_REQUEST_NUANCE = 'NAVIGATION_REQUEST_NUANCE';
export var NAVIGATION_REQUEST_VOICE_VERIFICATION = 'NAVIGATION_REQUEST_VOICE_VERIFICATION';
export var NAVIGATION_SET_NAVIGATION_ITEM = 'NAVIGATION_SET_NAVIGATION_ITEM';
export var NAVIGATION_SET_CONFIRMATION_REQUIRED = 'NAVIGATION_SET_CONFIRMATION_REQUIRED';
export var NAVIGATION_CLEAR_CONFIRMATION_REQUIRED = 'NAVIGATION_CLEAR_CONFIRMATION_REQUIRED';
export var NAVIGATION_SHOW_CONFIRMATION = 'NAVIGATION_SHOW_CONFIRMATION';
export var NAVIGATION_HIDE_CONFIRMATION = 'NAVIGATION_HIDE_CONFIRMATION';
export var NAVIGATION_NAVIGATE = 'NAVIGATION_NAVIGATE';
export var NAVIGATION_MASTHEAD_BACK_SHOW = 'NAVIGATION_MASTHEAD_BACK_SHOW';
export var NAVIGATION_MASTHEAD_BACK_HIDE = 'NAVIGATION_MASTHEAD_BACK_HIDE';
export var NAVIGATION_NAVIGATE_BACK = 'NAVIGATION_NAVIGATE_BACK';
export var NAVIGATION_PUSH_LOGOFF_PROMPT = 'NAVIGATION_PUSH_LOGOFF_PROMPT';
export var NAVIGATION_SET_LOGOFF_PROMPT_PUSHED = 'NAVIGATION_SET_LOGOFF_PROMPT_PUSHED';
export var NAVIGATION_ENABLE = 'NAVIGATION_ENABLE';
export var NAVIGATION_DISABLE = 'NAVIGATION_DISABLE';
export var NAVIGATION_FAILED = 'NAVIGATION_FAILED';
export var requestNavigation = function requestNavigation(navigationItem) {
  return {
    type: NAVIGATION_REQUEST_NAVIGATION,
    navigationItem: navigationItem
  };
};
export var requestNavigationWithId = function requestNavigationWithId(navigationItemId) {
  return {
    type: NAVIGATION_REQUEST_NAVIGATION_WITH_ID,
    navigationItemId: navigationItemId
  };
};
export var requestSamlNavigationBack = function requestSamlNavigationBack(payload) {
  return {
    type: NAVIGATION_REQUEST_SAML_BACK,
    payload: payload
  };
};
export var requestNuanceNavigation = function requestNuanceNavigation(payload) {
  return {
    type: NAVIGATION_REQUEST_NUANCE,
    payload: payload
  };
};
export var requestVoiceVerificationNavigation = function requestVoiceVerificationNavigation(payload) {
  return {
    type: NAVIGATION_REQUEST_VOICE_VERIFICATION,
    payload: payload
  };
};
export var setNavigationItem = function setNavigationItem(navigationItem) {
  return {
    type: NAVIGATION_SET_NAVIGATION_ITEM,
    navigationItem: navigationItem
  };
};
export var setNavigationConfirmationRequired = function setNavigationConfirmationRequired(payload) {
  return {
    type: NAVIGATION_SET_CONFIRMATION_REQUIRED,
    payload: payload
  };
};
export var clearNavigationConfirmationRequired = function clearNavigationConfirmationRequired() {
  return {
    type: NAVIGATION_CLEAR_CONFIRMATION_REQUIRED
  };
};
export var showConfirmation = function showConfirmation(payload) {
  return {
    type: NAVIGATION_SHOW_CONFIRMATION,
    payload: payload
  };
};
export var hideConfirmation = function hideConfirmation() {
  return {
    type: NAVIGATION_HIDE_CONFIRMATION
  };
};
export var navigate = function navigate() {
  return {
    type: NAVIGATION_NAVIGATE
  };
};
export var showMastheadBack = function showMastheadBack() {
  return {
    type: NAVIGATION_MASTHEAD_BACK_SHOW
  };
};
export var hideMastheadBack = function hideMastheadBack() {
  return {
    type: NAVIGATION_MASTHEAD_BACK_HIDE
  };
};
export var navigateBack = function navigateBack(locations) {
  return {
    type: NAVIGATION_NAVIGATE_BACK,
    locations: locations
  };
};
export var pushLogoffPrompt = function pushLogoffPrompt(path) {
  return {
    type: NAVIGATION_PUSH_LOGOFF_PROMPT,
    path: path
  };
};
export var setLogoffPromptPushed = function setLogoffPromptPushed(logoffPromptPushed) {
  return {
    type: NAVIGATION_SET_LOGOFF_PROMPT_PUSHED,
    logoffPromptPushed: logoffPromptPushed
  };
};
export var disableNavigation = function disableNavigation() {
  return {
    type: NAVIGATION_DISABLE
  };
};
export var enableNavigation = function enableNavigation() {
  return {
    type: NAVIGATION_ENABLE
  };
};
export var failedNavigation = function failedNavigation(failedNavigationItemId) {
  return {
    type: NAVIGATION_FAILED,
    failedNavigationItemId: failedNavigationItemId
  };
};